import * as React from 'react';
import { useIO, useModel } from '@type-r/react';
import { CollapsableSection, CompactTextArea, Flex, Loading, PopupIODialog } from 'lqx-react/src';
import { attributes, Events, subsetOf } from '@type-r/models';
import { makeStyles } from '@material-ui/core';
import { InvoiceItem } from '../../api';
import { InvoiceItemGrid } from '../../common';

const State = attributes({
    comment: String,
    invoiceItems: [InvoiceItem],    
    selected: subsetOf('invoiceItems')
})
type State = InstanceType<typeof State>;

export const MarkAsConfirmedDialog = ({$isOpen, relationshipId}) => {
    const state = useModel(State);

    const isReady = useIO(async() => {
        const invoiceItems = await InvoiceItem.fetchInvoiceItems('waiting-confirmation', relationshipId);
        state.invoiceItems.set(invoiceItems, {parse: true});
        state.selected.set(state.invoiceItems.models);
    });

    let styles = useStyles();
    
    const isValid = () => {
        return state.selected.length;
    }

    const markAsConfirmed = async () => {
        if (state && state.selected && state.selected.length) {
            const payload = {
                relationshipId: relationshipId,
                invoiceIds: Array.from(state.selected.map((i: InvoiceItem) => i.id)),
                comments: state.comment
            };    
            await InvoiceItem.executeAction('mark-as-confirmed', payload);
        }
    }
    
    return (
        <PopupIODialog
            $isOpen={$isOpen}
            title={'Mark Invoices as Confirmed'}
            actionLabel={'Mark as Confirmed'}
            success={'Successfully marked invoices as confirmed.'}
            disabled={!isValid()}
            onSuccess={() => Events.trigger("Landing:notSentChanged")} 
            doIO={markAsConfirmed}
        >
            <Flex className={styles.popup}>
            {
                isReady ? 
                    <CollapsableSection title={`Select Invoices`}>
                        <InvoiceItemGrid invoiceItems={state.invoiceItems} $selected={state.$.selected as any}/>
                    </CollapsableSection>
                    : <Loading />
            }
                <CompactTextArea label="Comments" $value={state.$.comment} />
            </Flex>
        </PopupIODialog>
    );    
}

const useStyles = makeStyles({
    popup: {
        minHeight: 400
    }
});